'use client';

import { useTranslations } from 'next-intl';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations('errors');

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center px-4 text-center">
      <div className="mb-4 text-7xl font-bold text-error-500">500</div>
      <h1 className="text-2xl font-semibold text-text-primary mb-2">
        {t('serverError')}
      </h1>
      <p className="text-text-secondary mb-8 max-w-md">
        {t('serverErrorDescription')}
      </p>
      <button
        onClick={reset}
        className="inline-flex h-11 items-center rounded-lg bg-primary-500 px-6 text-sm font-medium text-white hover:bg-primary-600 transition-colors duration-200"
      >
        Erneut versuchen
      </button>
    </div>
  );
}
